"use client";
import * as React from "react";

type ItemRowProps = {
  inputType: "text" | "url" | "number" | "password";
  item: string;
  index: number;
  handleItemUpdate: (newItem: string, index: number) => void;
  handleItemDelete: (index: number) => void;
  handleBlur: (index: number) => void;
  isDuplicateItem?: boolean;
  disableDelete?: boolean;
  disabled?: boolean;
  classNames: {
    input: string;
  };
};
import XMarkIcon from "../../icons/XMarkIcon";
import styles from "../index.module.css";
import itemStyles from "./index.module.css";

function ItemRow(props: ItemRowProps) {
  return (
    <div className={itemStyles.row}>
      <input
        name="item"
        type={props.inputType || "text"}
        className={`${props.classNames.input} ${styles["input-sm"]} ${itemStyles["input"]}`}
        value={props.item}
        onChange={(event) =>
          props.handleItemUpdate(event.target.value, props.index)
        }
        onBlur={(event) => props.handleBlur(props.index)}
        required
        disabled={props.disabled}
      />
      <button
        type="button"
        onClick={(event) => props.handleItemDelete(props.index)}
        disabled={props.disableDelete}
      >
        <XMarkIcon
          svgAttrs={{
            class: itemStyles["svg"],
          }}
        />
      </button>
    </div>
  );
}

export default ItemRow;
